import * as React from 'react';
import * as toastr from 'toastr'
import {forwardRef, useImperativeHandle, useRef, useState} from "react";

const Modal = require('react-modal');

interface Props {
    handleSaveSearch(searchName: string): void;
}

const customStyles = {
    content: {
        border: 'none',
        backgroundColor: "transparent",
        margin: 'auto',
        overflow: 'hidden',
        height: 360
    }
};

const SaveSearchModal = forwardRef((props: Props, ref) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [searchName, _setSearchName] = useState<string>('');
    const searchNameRef = useRef(searchName);

    const setSearchName = data => {
        searchNameRef.current = data;
        _setSearchName(data);
    };

    // Used for exposing show and hide props
    useImperativeHandle(ref, () => {
        return {
            show: show,
            hide: hide
        };
    });

    const show = () => {
        setIsOpen(true);
    };

    const hide = () => {
        setIsOpen(false);
        setSearchName('');
    };

    const onInputKeyDown = (e) => {
        if (e.key === 'Enter') {
            onSave();
        }
        if (e.key === "Escape") {
            hide();
        }
    };

    const onSave = () => {
        if (searchNameRef.current !== '') {
            props.handleSaveSearch(searchNameRef.current);
        } else {
            toastr.warning("Search name cannot be empty!");
        }
    };

    const onNameChange = (evt: any) => {
        setSearchName(evt.target.value);
    }

    return (
        <Modal
            isOpen={isOpen}
            style={customStyles}
            ariaHideApp={false}
            onClose={hide}
        >
            <div style={{width: 360, backgroundColor: "rgba(0,0,0,0.4)"}}
                 className={"container-fluid"}>
                <div className={"row"}>
                    <div className={"col-lg-10"} style={{marginTop: 7}}>
                        <label style={{color: "white", fontSize: 20}}>Create Saved Search</label>
                    </div>
                    <div className={"col-lg-2"}>
                        <i onClick={hide}
                           style={{float: "right", cursor: "pointer", fontSize: 30, padding: 0, margin: 0}}
                           className={"fa fa-window-close btn"}
                           aria-hidden={"true"}/>
                    </div>
                </div>
                <div style={{marginBottom: 10, marginTop: 10}} className={"row"}>
                    <div className={"col-lg-12"}>
                        <label htmlFor={"searchNameInput"} style={{color: "white", fontSize: 16,}}>Search Name</label>
                    </div>
                    <div className={"col-lg-12"}>
                        <input id={"searchNameInput"}
                               autoFocus={true}
                               value={searchName}
                               onChange={onNameChange}
                               onKeyDown={onInputKeyDown}
                               style={{width: "100%", height: 40, fontSize: 16}} type={"text"}/>
                    </div>
                </div>
                <div style={{marginTop: 5, marginBottom: 2}} className={"row"}>
                    <div className={"col-lg-12"}>
                        <button onClick={onSave} style={{float: "right"}} className={"btn"}>Save Search</button>
                    </div>
                </div>
            </div>
        </Modal>
    )
})

export default SaveSearchModal;



// WEBPACK FOOTER //
// ./app/components/bo-core/modals/SaveSearchModal.tsx